import { render, staticRenderFns } from "./stay-review.vue?vue&type=template&id=13e82def&"
import script from "./stay-review.vue?vue&type=script&lang=js&"
export * from "./stay-review.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports